import { SORT_COLUMN, UPDATE_DATA, FILTER_PS_DATA } from "../actions/types";

const INITIAL_STATE = {
  sort: {
    order: "asc",
    orderBy: ""
  },
  pagination: {
    page: 0,
    rowsPerPage: 5
  },
  filter: {
    maxPkEnergy: ""
  },
  updatedData: []
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case FILTER_PS_DATA:
      return {
        ...state,
        filter: {
          maxPkEnergy: payload
        }
      };
    case SORT_COLUMN:
      return {
        ...state,
        sort: {
          order: payload.order,
          orderBy: payload.orderBy
        }
      };
    case UPDATE_DATA:
      return { ...state, updatedData: payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/table_reducer.js